function getBrowserPath() {
  return window.location.pathname + (window.location.search || '');
}

export function connectHistory({ router }) {
  router.subscribe(({ newPath, prevPath }) => {
    // The `router.go` call below will execute this function with a
    // `prevPath` of `null` once. Since this is the "initial route", we
    // want to `replaceState` rather than `pushState`. This prevents an
    // annoying back loop when coming into a route that was redirected.
    if (prevPath === null) {
      window.history.replaceState(null, null, newPath);
    } else if (newPath !== window.location.pathname) {
      window.history.pushState(null, null, newPath);
    }
  });

  function handlePopState() {
    router.go(getBrowserPath());
  }

  window.addEventListener('popstate', handlePopState);

  // Go to the window's location when this connector is called. Ultimately,
  // `history` should drive the initialization of the router in the browser
  // environment.
  router.go(getBrowserPath());

  return () => window.removeEventListener('popstate', handlePopState);
}
